import React, { Component } from 'react';


import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import {bizpost} from '../../ajax';

import ClosableBar from './ClosableBar';

const s:any = {
  submitBtn: {
    marginLeft: 10
  },
};
// const s:any = {
//   submitBtn: {
//     marginLeft: 10
//   }
// };

class LogoutWizard extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
    this.state = {
      open: null
    };
  }

  stopLoading = () => {
    const {stopProgress} = this.props;
    if(typeof stopProgress === 'function') stopProgress();
  }

  handleOpen = () => {
    this.setState({open: true});
  };

  handleClose = () => {
    this.setState({open: false});
  };

  handleLogout = async() => {
    var that = this;
    try{
      const json = {s:'security',a:'logout'};
      const response = await bizpost(json);
      console.log('login response ',response);
      document.location.reload();
    }
    catch(error){
      that.setState({open:false});
      that.props.close();
      //this.showNotification(error.message||"request failed",error.type||'warn',error.title||'Loading Error');
    }
    finally{
      this.stopLoading();
    }
  }

  render() {
    const {open,cancelLogout,classes} = this.props;
    const title = "User Logout";

    return (
      // <Box>
      <Dialog open={open}  sx={{...s.dialog}} slotProps={{paper: {sx:s.dialogcontent}}} maxWidth={'md'}>
          <DialogTitle sx={{...s.titlebar}}>
            <ClosableBar onClose={cancelLogout}>{title}</ClosableBar>
          </DialogTitle>
          <DialogContent sx={{...s.dialogcontent}}>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to logout?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button variant="contained" color="secondary" onClick={cancelLogout}>No, Cancel</Button>
            <Button variant="contained" color="primary" onClick={this.handleLogout}>Yes, Logout</Button> {/*sx={{...s.submitBtn}}*/}
          </DialogActions>
        </Dialog>
      // </Box>
    );
  }
}

export default LogoutWizard;
